import { Link, useLocalSearchParams } from 'expo-router';
import { ScrollView } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { useQuery, useSubscription } from 'urql';
import FadeInContent from '@/components/Animation/FadeInContent';
import EventStandings, {
  EventStandingsFragment,
  EventTeamStandingsFragment,
} from '@/components/Event/EventStandings';
import ActionBar from '@/components/UI/ActionBar';
import ActionButton from '@/components/UI/ActionButton';
import Box from '@/components/UI/Box';
import { graphql } from '@/gql/graphql';

const GetEventDetailStandings = graphql(/* GraphQL */ `
  query GetEventDetailStandings($eventId: uuid!) {
    ...EventStandings
  }
`, [EventStandingsFragment]);

const WatchEventDetailStandings = graphql(/* GraphQL */ `
  subscription WatchDetailEventStandings($eventId: uuid!) {
    team_standing(args: { id: $eventId }) {
      ...EventTeamStandings
    }
  }
`, [EventTeamStandingsFragment]);

export default function EventDetailStandings() {
  const { eventId: eventIdParam } = useLocalSearchParams<{
    eventId?: string;
  }>();
  const eventId = eventIdParam || '';

  const [{ data, fetching }] = useQuery({
    query: GetEventDetailStandings,
    variables: {
      eventId,
    },
  });

  useSubscription({
    query: WatchEventDetailStandings,
    variables: {
      eventId,
    },
  });

  return (
    <FadeInContent fetching={fetching}>
      <ScrollView contentContainerStyle={style.content}>
        <Box direction="vertical" flex space="md">
          <ActionBar>
            <Link
              href={{
                pathname: '/event/[eventId]/standings/share',
                params: { eventId },
              }}
              asChild
            >
              <ActionButton
                forceLabel
                label="Share"
                icon="share-outline"
                variant="secondary"
              />
            </Link>
          </ActionBar>

          <EventStandings data={data} fetching={fetching} />
        </Box>
      </ScrollView>
    </FadeInContent>
  );
}

const style = StyleSheet.create({
  content: {
    flexGrow: 1,
  },
});
